var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2807_11140)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 25.5L18.75 22.375V16.125L21.3389 13.5362C23.683 11.192 25 8.01253 25 4.69733V0.5H20.8027C17.4875 0.5 14.308 1.81696 11.9638 4.16117L9.375 6.75H3.125L0 9.875L15.625 25.5ZM16.4062 11.4375C17.7006 11.4375 18.75 10.3882 18.75 9.09375C18.75 7.79933 17.7006 6.75 16.4062 6.75C15.1118 6.75 14.0625 7.79933 14.0625 9.09375C14.0625 10.3882 15.1118 11.4375 16.4062 11.4375Z",
    fill: "url(#paint0_linear_2807_11140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69906 21.9943L3.50661 17.8018L0 23.9383L1.5625 25.5008L7.69906 21.9943Z",
    fill: "url(#paint1_linear_2807_11140)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2807_11140",
    x1: 12.5,
    y1: 0.5,
    x2: 12.5,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4318FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#280F99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2807_11140",
    x1: 3.84953,
    y1: 17.8018,
    x2: 3.84953,
    y2: 25.5008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4318FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#280F99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2807_11140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.eae14226a384eefb0f48206be7b7a1a5.svg";
export { ForwardRef as ReactComponent };